import { useInView } from "react-intersection-observer"
import * as styles from "./styles.module.scss"
import cimney from "./images/tesla-cimney.svg"
import cx from "classnames"
import home from "./images/tesla-home.svg"
import Odometer from "../../Odometer"
import * as React from "react"
import roofBack from "./images/tesla-roof-back.svg"
import roofFront from "./images/tesla-roof-front.svg"
import Superscript from "../../Superscript"

const EquityRoof: React.FC = () => {
  const [ref, inView] = useInView({
    threshold: 0,
  })
  const initialValueTotal = 500000
  const finalValueTotal = 530000
  const initialValueRoof = 0
  const finalValueRoof = 30000

  return (
    <div
      className={cx({
        [styles.equityRoof]: true,
        [styles.inView]: inView,
      })}
      ref={ref}
    >
      <div className={styles.above}>
        <div className={styles.figureWrap}>
          <figure className={styles.figure}>
            <img className={styles.roofBack} src={roofBack} alt="Solar Roof" />
            <img className={styles.home} src={home} alt="Home" />
            <img
              className={styles.roofFront}
              src={roofFront}
              alt="Solar Roof"
            />
            <img className={styles.cimney} src={cimney} alt="Cimney" />
          </figure>
        </div>
        <div className={styles.caption}>
          <div className={styles.roofValue} data-js-equity-roof-spacer>
            <div className={styles.indicator} />
            <div className={styles.value}>
              <div className={styles.valueMd}>
                <span>$</span>
                <Odometer
                  format="(,ddd)"
                  duration={500}
                  value={inView ? finalValueRoof : initialValueRoof}
                />
              </div>
              <div className={styles.labelSm}>Solar Roof</div>
            </div>
          </div>
          <div className={styles.homeValue}>
            <div className={styles.indicator} />
            <div className={styles.value}>
              <div className={styles.valueMd}>$500,000</div>
              <div className={styles.labelSm}>Home value</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.below}>
        <div className={styles.solarMortagageValue}>
          <div
            className={cx({
              [styles.valueLg]: true,
              [styles.green]: true,
            })}
          >
            <span>$</span>
            <Odometer
              format="(,ddd)"
              duration={500}
              value={inView ? finalValueTotal : initialValueTotal}
            />
          </div>
          <div
            className={cx({
              [styles.labelMd]: true,
              [styles.green]: true,
            })}
          >
            Home value with a Solar Mortgage
            <Superscript>TM</Superscript>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EquityRoof
